"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ChatbotsApi = void 0;

var _http = require("../http");

var _constants = require("../constants");

var _util = require("../util");

var _types = require("../store/types");

var _ChatbotsApiUtil = _interopRequireDefault(require("./ChatbotsApiUtil"));

var _store = require("../store");

var _app = require("../store/actions/app");

var _conversation = require("../store/actions/conversation");

var _LiveEngageConfig = _interopRequireDefault(require("./LiveEngageConfig"));

var _app2 = require("../store/selectors/app");

var _traffic = require("../store/actions/traffic");

var _conversation2 = require("../store/selectors/conversation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ChatbotsApi =
/*#__PURE__*/
function () {
  function ChatbotsApi(newStore) {
    _classCallCheck(this, ChatbotsApi);

    this.store = newStore || _store.store;
    this.endpoint = null;

    this.debug = function () {};

    this.liveEngageConfig = null;
  }

  _createClass(ChatbotsApi, [{
    key: "init",
    value: function init(newStore) {
      var _this = this;

      var env, product, envPrefix;
      return regeneratorRuntime.async(function init$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.store = newStore || _store.store;
              env = (0, _app2.getAppEnv)(this.store.getState());
              product = (0, _app2.getAppProduct)(this.store.getState());
              envPrefix = {
                prod: '',
                dev: "".concat(_constants.ENV_STRINGS.dev, "-"),
                test: "".concat(_constants.ENV_STRINGS.test, "-")
              }[env];
              this.endpoint = "https://".concat(_constants.API_HOST, ".").concat(envPrefix, "godaddy.com");

              this.debug = function () {
                return (0, _app2.getAppDebug)(_this.store.getState());
              };

              this.liveEngageConfig = (0, _LiveEngageConfig["default"])(env, product);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getPredefinedParams",
    value: function getPredefinedParams() {
      return {
        nopbjs: 1,
        vid: (0, _util.getUserInfo)() ? (0, _util.getUserInfo)().visitorId : '',
        pid: (0, _app2.getAppProduct)(this.store.getState())
      };
    }
  }, {
    key: "appendConversation",
    value: function appendConversation(conversationResult) {
      var error, responses;
      return regeneratorRuntime.async(function appendConversation$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (conversationResult) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return regeneratorRuntime.awrap(this.store.dispatch({
                payload: 'No conversation results to append',
                type: _types.APP_ERROR_SET
              }));

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 4:
              error = conversationResult.error, responses = conversationResult.responses;

              if (!error) {
                _context2.next = 9;
                break;
              }

              _context2.next = 8;
              return regeneratorRuntime.awrap(this.store.dispatch({
                payload: error,
                type: _types.APP_ERROR_SET
              }));

            case 8:
              return _context2.abrupt("return", _context2.sent);

            case 9:
              if (!(responses.length < 1)) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return");

            case 11:
              _context2.next = 13;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appBlockedSet)(true)));

            case 13:
              _context2.next = 15;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.conversationQueueAppend)(responses)));

            case 15:
              _context2.next = 17;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.processQueue)()));

            case 17:
              if (!((0, _app2.getAppContext)(this.store.getState()) === _constants.CONTEXT_CHATBOTS_API)) {
                _context2.next = 20;
                break;
              }

              _context2.next = 20;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appBlockedSet)(false)));

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "send",
    value: function send(utterance, event) {
      var validation, utteranceResults;
      return regeneratorRuntime.async(function send$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              validation = (0, _app2.getAppInputValidation)(this.store.getState());

              if (!validation) {
                _context3.next = 5;
                break;
              }

              _context3.next = 4;
              return regeneratorRuntime.awrap(this.processValidation(utterance, validation));

            case 4:
              return _context3.abrupt("return");

            case 5:
              _context3.next = 7;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent(utterance, event));

            case 7:
              utteranceResults = _context3.sent;
              _context3.next = 10;
              return regeneratorRuntime.awrap(this.appendConversation(utteranceResults));

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "sendUtteranceOrEvent",
    value: function sendUtteranceOrEvent(utterance, event) {
      var response, _ref, payload, error, queryResult, intent, i, resultMessage, messageType, _ref2, availability, utteranceResult, authResult, eventResult, queriedResult, setBotResult, variables;

      return regeneratorRuntime.async(function sendUtteranceOrEvent$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              response = {
                error: null,
                responses: []
              };
              _context4.next = 3;
              return regeneratorRuntime.awrap(this.detectIntent(utterance, event));

            case 3:
              _ref = _context4.sent;
              payload = _ref.data;
              error = _ref.error;
              // eslint-disable-next-line no-console
              this.log("CA Response:", payload);

              if (!error) {
                _context4.next = 11;
                break;
              }

              // eslint-disable-next-line no-console
              console.info("CA Error", error);
              response.error = error;
              return _context4.abrupt("return", response);

            case 11:
              if (payload.responseData) {
                _context4.next = 14;
                break;
              }

              // eslint-disable-next-line no-console
              this.log("CA No responses.");
              return _context4.abrupt("return", response);

            case 14:
              queryResult = payload.responseData.queryResult;
              queryResult.variables = _objectSpread({}, queryResult.waitTimes, {}, queryResult.escalate); // todo remove this line once chatbot api has this node.

              (this.debug() || this.env === 'dev') && response.responses.push({
                type: _constants.CONVERSATION_TYPE_DIAG_BOT,
                items: _ChatbotsApiUtil["default"].getDiagnostics(queryResult)
              });

              if (queryResult.fulfillmentMessages) {
                _context4.next = 19;
                break;
              }

              return _context4.abrupt("return", response);

            case 19:
              intent = queryResult.intent && queryResult.intent.displayName || '';
              i = 0;

            case 21:
              if (!(i < queryResult.fulfillmentMessages.length)) {
                _context4.next = 89;
                break;
              }

              resultMessage = queryResult.fulfillmentMessages[i];
              messageType = resultMessage.type || 'unknown';

              if (messageType === 'payload' && resultMessage.payload.type) {
                messageType = resultMessage.payload.type;
              }

              this.store.dispatch((0, _traffic.trafficBotActionMessageSent)({
                intent: intent,
                type: messageType,
                message: resultMessage
              }));
              this.store.dispatch((0, _traffic.trafficSurveyQuestionShown)({
                intent: intent,
                type: messageType,
                message: resultMessage
              })); // eslint-disable-next-line no-console

              this.log("CA Msgs ".concat(messageType), resultMessage);
              _context4.t0 = messageType;
              _context4.next = _context4.t0 === _constants.PAYLOAD_TYPE.AGENT_TRANSFER ? 31 : _context4.t0 === _constants.PAYLOAD_TYPE.API ? 46 : _context4.t0 === _constants.PAYLOAD_TYPE.AUTH_CHECK ? 48 : _context4.t0 === _constants.PAYLOAD_TYPE.BUTTON ? 53 : _context4.t0 === _constants.PAYLOAD_TYPE.EVENT ? 59 : _context4.t0 === _constants.PAYLOAD_TYPE.POST_TO_CRM ? 64 : _context4.t0 === _constants.PAYLOAD_TYPE.QUERY_BOT_AGENT ? 66 : _context4.t0 === _constants.PAYLOAD_TYPE.SET_BOT_AGENT ? 71 : _context4.t0 === _constants.PAYLOAD_TYPE.SET_STATE ? 76 : _context4.t0 === _constants.PAYLOAD_TYPE.TEXT ? 79 : _context4.t0 === _constants.PAYLOAD_TYPE.VALIDATOR ? 81 : _context4.t0 === _constants.PAYLOAD_TYPE.SETTINGS ? 83 : 85;
              break;

            case 31:
              _context4.next = 33;
              return regeneratorRuntime.awrap(this.getAgentAvailability());

            case 33:
              _ref2 = _context4.sent;
              availability = _ref2.availability;

              if (!availability) {
                _context4.next = 40;
                break;
              }

              _context4.next = 38;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appAgentTransfer)()));

            case 38:
              _context4.next = 45;
              break;

            case 40:
              _context4.next = 42;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', _constants.EVENT_TYPE_CHAT_OFFLINE));

            case 42:
              utteranceResult = _context4.sent;
              this.pushResults(response, utteranceResult);
              this.store.dispatch((0, _traffic.trafficAgentUnavailable)());

            case 45:
              return _context4.abrupt("break", 86);

            case 46:
              response.responses.push(this.processApi(resultMessage, queryResult));
              return _context4.abrupt("break", 86);

            case 48:
              _context4.next = 50;
              return regeneratorRuntime.awrap(this.processAuthCheck(resultMessage, queryResult));

            case 50:
              authResult = _context4.sent;
              this.pushResults(response, authResult);
              return _context4.abrupt("break", 86);

            case 53:
              _context4.t1 = response.responses;
              _context4.next = 56;
              return regeneratorRuntime.awrap(this.processButton(resultMessage, queryResult));

            case 56:
              _context4.t2 = _context4.sent;

              _context4.t1.push.call(_context4.t1, _context4.t2);

              return _context4.abrupt("break", 86);

            case 59:
              _context4.next = 61;
              return regeneratorRuntime.awrap(this.processEvent(resultMessage));

            case 61:
              eventResult = _context4.sent;
              this.pushResults(response, eventResult);
              return _context4.abrupt("break", 86);

            case 64:
              this.processPostToCRM(resultMessage, utterance);
              return _context4.abrupt("break", 86);

            case 66:
              _context4.next = 68;
              return regeneratorRuntime.awrap(this.processQueryBotAgent(resultMessage, utterance));

            case 68:
              queriedResult = _context4.sent;
              this.pushResults(response, queriedResult);
              return _context4.abrupt("break", 86);

            case 71:
              _context4.next = 73;
              return regeneratorRuntime.awrap(this.processSetBotAgent(resultMessage));

            case 73:
              setBotResult = _context4.sent;
              this.pushResults(response, setBotResult);
              return _context4.abrupt("break", 86);

            case 76:
              variables = resultMessage.payload.valueType === 'waitTimes' ? queryResult.variables : resultMessage.payload.state;
              this.store.dispatch((0, _app.appVariablesSet)(variables || {}));
              return _context4.abrupt("break", 86);

            case 79:
              response.responses.push(this.processText(resultMessage, queryResult));
              return _context4.abrupt("break", 86);

            case 81:
              resultMessage.payload && this.store.dispatch((0, _app.appInputValidationSet)(_objectSpread({}, resultMessage.payload.validation)));
              return _context4.abrupt("break", 86);

            case 83:
              this.processSettings(resultMessage);
              return _context4.abrupt("break", 86);

            case 85:
              return _context4.abrupt("break", 86);

            case 86:
              i++;
              _context4.next = 21;
              break;

            case 89:
              return _context4.abrupt("return", response);

            case 90:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "pushResults",
    value: function pushResults(response, results) {
      if (!results || results.error) {
        return results;
      }

      results.responses.forEach(function (item) {
        return response.responses.push(item);
      });
    }
  }, {
    key: "processAuthCheck",
    value: function processAuthCheck(msg, queryResult) {
      var api, isAuthenticated, authEvent, response;
      return regeneratorRuntime.async(function processAuthCheck$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              api = queryResult.api;

              if (api) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return");

            case 3:
              isAuthenticated = api.type === 'shopper' && !api.error && api.result && api.result.shopperId;
              authEvent = isAuthenticated ? msg.payload.authenticatedEvent : msg.payload.unauthenticatedEvent;
              _context5.next = 7;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', authEvent));

            case 7:
              response = _context5.sent;
              return _context5.abrupt("return", response);

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "processEvent",
    value: function processEvent(msg) {
      var eventName, response;
      return regeneratorRuntime.async(function processEvent$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(!msg || !msg.payload || !msg.payload.name)) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return");

            case 2:
              eventName = msg.payload.name;
              _context6.next = 5;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', eventName));

            case 5:
              response = _context6.sent;
              return _context6.abrupt("return", response);

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "detectIntent",
    value: function detectIntent(utterance, event) {
      var params;
      return regeneratorRuntime.async(function detectIntent$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              params = _objectSpread({}, this.getPredefinedParams());
              if (utterance) params.q = utterance;
              if (event) params.e = event;
              params.sid = (0, _app2.getAppSessionId)(this.store.getState());
              params.projectId = (0, _app2.getAppBotProjectId)(this.store.getState());
              _context7.next = 7;
              return regeneratorRuntime.awrap((0, _http.request)({
                method: 'get',
                params: params,
                withCredentials: true,
                url: "".concat(this.endpoint, "/").concat(_constants.CHATBOT_API_ENDPOINTS.DETECT_INTENT)
              }));

            case 7:
              return _context7.abrupt("return", _context7.sent);

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "queryIntent",
    value: function queryIntent(utterance, botProjectId) {
      var params;
      return regeneratorRuntime.async(function queryIntent$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              params = _objectSpread({}, this.getPredefinedParams());
              if (utterance) params.q = utterance;
              params.sid = (0, _app2.getAppSessionId)(this.store.getState());
              if (botProjectId) params.projectId = botProjectId;
              _context8.next = 6;
              return regeneratorRuntime.awrap((0, _http.request)({
                method: 'get',
                params: params,
                url: "".concat(this.endpoint, "/").concat(_constants.CHATBOT_API_ENDPOINTS.QUERY_INTENT)
              }));

            case 6:
              return _context8.abrupt("return", _context8.sent);

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "processQueryBotAgent",
    value: function processQueryBotAgent(resultMessage, utterance) {
      var response, eventToTrigger, _ref3, data, error, _resultMessage$payloa, stopCondition, eventNameProceed, eventNameStop, intentName, matchExcludeIntents;

      return regeneratorRuntime.async(function processQueryBotAgent$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              response = {
                error: null,
                responses: []
              };
              eventToTrigger = null;

              if (!(resultMessage && resultMessage.payload && resultMessage.payload.botProjectId)) {
                _context9.next = 15;
                break;
              }

              _context9.next = 5;
              return regeneratorRuntime.awrap(this.queryIntent(utterance, resultMessage.payload.botProjectId));

            case 5:
              _ref3 = _context9.sent;
              data = _ref3.data;
              error = _ref3.error;
              error = error || data && data.error || null;

              if (!error) {
                _context9.next = 12;
                break;
              }

              response.error = error;
              return _context9.abrupt("return", response);

            case 12:
              // BREAK HERE
              _resultMessage$payloa = resultMessage.payload, stopCondition = _resultMessage$payloa.stopCondition, eventNameProceed = _resultMessage$payloa.eventNameProceed, eventNameStop = _resultMessage$payloa.eventNameStop;
              intentName = data.responseData && data.responseData.queryResult && data.responseData.queryResult.intent && data.responseData.queryResult.intent.displayName;

              if (intentName) {
                matchExcludeIntents = stopCondition.find(function (intent) {
                  return intentName.toLowerCase().indexOf(intent) > -1;
                });
                eventToTrigger = matchExcludeIntents ? eventNameStop : eventNameProceed;
              }

            case 15:
              if (!eventToTrigger) {
                _context9.next = 20;
                break;
              }

              _context9.next = 18;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', eventToTrigger));

            case 18:
              response = _context9.sent;
              return _context9.abrupt("return", response);

            case 20:
              return _context9.abrupt("return", response);

            case 21:
            case "end":
              return _context9.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "processSetBotAgent",
    value: function processSetBotAgent(msg) {
      var response, botProjectId, nextEvent, nextUtteranceIndex, utteranceAtIndexText, product, defaultEvent;
      return regeneratorRuntime.async(function processSetBotAgent$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              response = {
                error: null,
                responses: []
              };
              botProjectId = msg.payload.botProjectId;
              _context10.next = 4;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appBotProjectIdSet)(botProjectId)));

            case 4:
              nextEvent = msg.payload && msg.payload.nextEvent;

              if (!nextEvent) {
                _context10.next = 10;
                break;
              }

              _context10.next = 8;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', nextEvent));

            case 8:
              response = _context10.sent;
              return _context10.abrupt("return", response);

            case 10:
              nextUtteranceIndex = msg.payload && msg.payload.nextUtteranceIndex;

              if (isNaN(nextUtteranceIndex)) {
                _context10.next = 18;
                break;
              }

              utteranceAtIndexText = (0, _conversation2.getConversationUtteranceAtIndexText)(this.store.getState(), nextUtteranceIndex);

              if (!utteranceAtIndexText) {
                _context10.next = 18;
                break;
              }

              _context10.next = 16;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent(utteranceAtIndexText, ''));

            case 16:
              response = _context10.sent;
              return _context10.abrupt("return", response);

            case 18:
              product = (0, _app2.getAppProduct)(this.store.getState());
              defaultEvent = _ChatbotsApiUtil["default"].getFallbackIntentEventId(product);
              _context10.next = 22;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', defaultEvent));

            case 22:
              response = _context10.sent;
              return _context10.abrupt("return", response);

            case 24:
            case "end":
              return _context10.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "processValidation",
    value: function processValidation(utterance, validation) {
      var cancelResult, isValid, failedResult, utteranceResult, racResults;
      return regeneratorRuntime.async(function processValidation$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!(utterance && utterance.toLowerCase() === validation.cancelText)) {
                _context11.next = 8;
                break;
              }

              this.store.dispatch((0, _app.appInputValidationSet)(null));
              _context11.next = 4;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', validation.cancel));

            case 4:
              cancelResult = _context11.sent;
              _context11.next = 7;
              return regeneratorRuntime.awrap(this.appendConversation(cancelResult));

            case 7:
              return _context11.abrupt("return");

            case 8:
              isValid = validation.matchRegEx && validation.matchRegEx.some(function (r) {
                return utterance.match(new RegExp(r));
              });

              if (!(!isValid && validation.failed)) {
                _context11.next = 16;
                break;
              }

              _context11.next = 12;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', validation.failed));

            case 12:
              failedResult = _context11.sent;
              _context11.next = 15;
              return regeneratorRuntime.awrap(this.appendConversation(failedResult));

            case 15:
              return _context11.abrupt("return");

            case 16:
              if (!isValid) {
                _context11.next = 29;
                break;
              }

              this.store.dispatch((0, _app.appInputValidationSet)(null));
              _context11.next = 20;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent(utterance));

            case 20:
              utteranceResult = _context11.sent;
              _context11.next = 23;
              return regeneratorRuntime.awrap(this.appendConversation(utteranceResult));

            case 23:
              if (!(validation.action === 'rac')) {
                _context11.next = 29;
                break;
              }

              _context11.next = 26;
              return regeneratorRuntime.awrap(this.getRacResults(utterance, validation));

            case 26:
              racResults = _context11.sent;
              _context11.next = 29;
              return regeneratorRuntime.awrap(this.appendConversation(racResults));

            case 29:
            case "end":
              return _context11.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "processPostToCRM",
    value: function processPostToCRM() {
      var shopperId, conversationTranscript, appProductContext, body;
      return regeneratorRuntime.async(function processPostToCRM$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              shopperId = (0, _util.getUserInfo)() ? (0, _util.getUserInfo)().shopperId : '';

              if (shopperId) {
                _context12.next = 4;
                break;
              }

              this.log('CRM data failed to send, since user is not logged in'); // eslint-disable-line no-console

              return _context12.abrupt("return");

            case 4:
              _context12.next = 6;
              return regeneratorRuntime.awrap((0, _conversation2.getConversationTranscript)(this.store.getState()));

            case 6:
              conversationTranscript = _context12.sent;
              _context12.next = 9;
              return regeneratorRuntime.awrap((0, _app2.getAppProductContext)(this.store.getState(), (0, _app2.getAppEnv)(this.store.getState())));

            case 9:
              appProductContext = _context12.sent;
              body = {
                shopperId: shopperId,
                conversationText: conversationTranscript + '\n' + appProductContext
              };
              _context12.next = 13;
              return regeneratorRuntime.awrap((0, _http.request)(_objectSpread({}, _util.postProps, {
                data: body,
                url: "".concat(this.endpoint, "/").concat(_constants.CHATBOT_API_ENDPOINTS.POST_TO_CRM),
                withCredentials: true
              })));

            case 13:
            case "end":
              return _context12.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getRacResults",
    value: function getRacResults(utterance, validation) {
      var _validation$actionSuc, actionSuccess, _validation$actionFai, actionFailed, variables, phoneWaitTime, waitTimeInMin, businessFields, body, _ref4, data;

      return regeneratorRuntime.async(function getRacResults$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!(validation.action === 'rac')) {
                _context13.next = 26;
                break;
              }

              _validation$actionSuc = validation.actionSuccess, actionSuccess = _validation$actionSuc === void 0 ? 'success-event' : _validation$actionSuc, _validation$actionFai = validation.actionFailed, actionFailed = _validation$actionFai === void 0 ? 'failed-event' : _validation$actionFai;
              variables = this.getVariables();
              phoneWaitTime = variables.phoneWaitTime;
              waitTimeInMin = phoneWaitTime && !isNaN(phoneWaitTime) && Number(phoneWaitTime);

              if (!(waitTimeInMin === 'undefined' || waitTimeInMin && waitTimeInMin < 0)) {
                _context13.next = 9;
                break;
              }

              _context13.next = 8;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', actionFailed));

            case 8:
              return _context13.abrupt("return", _context13.sent);

            case 9:
              variables.waitTimeInSec = waitTimeInMin * 60;
              variables.utterance = utterance;
              businessFields = _ChatbotsApiUtil["default"].getBusinessField(variables);
              body = _ChatbotsApiUtil["default"].createRacBody(businessFields);
              _context13.next = 15;
              return regeneratorRuntime.awrap((0, _http.request)({
                data: body,
                method: 'post',
                headers: {
                  'Content-Type': 'application/json'
                },
                url: "".concat(this.endpoint, "/").concat(_constants.CHATBOT_API_ENDPOINTS.ADD_CONTACT),
                withCredentials: true
              }));

            case 15:
              _ref4 = _context13.sent;
              data = _ref4.data;

              if (!(data && data.status === 200 && data.statusMessage === 'SUCCESS')) {
                _context13.next = 22;
                break;
              }

              this.store.dispatch((0, _traffic.trafficRacTriggered)(_objectSpread({}, businessFields, {
                status: 'SUCCESS'
              })));
              _context13.next = 21;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', actionSuccess));

            case 21:
              return _context13.abrupt("return", _context13.sent);

            case 22:
              this.store.dispatch((0, _traffic.trafficRacTriggered)(_objectSpread({}, businessFields, {
                status: 'FAILED'
              })));
              _context13.next = 25;
              return regeneratorRuntime.awrap(this.sendUtteranceOrEvent('', actionFailed));

            case 25:
              return _context13.abrupt("return", _context13.sent);

            case 26:
            case "end":
              return _context13.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "processButton",
    value: function processButton(resultMessage, queryResult) {
      var _ref5, availability, _ref6, estimatedWaitTime, buttons;

      return regeneratorRuntime.async(function processButton$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              queryResult.variables = this.getVariables(queryResult);

              if (!_ChatbotsApiUtil["default"].hasChatButton(resultMessage)) {
                _context14.next = 12;
                break;
              }

              _context14.next = 4;
              return regeneratorRuntime.awrap(this.getAgentAvailability());

            case 4:
              _ref5 = _context14.sent;
              availability = _ref5.availability;
              _context14.next = 8;
              return regeneratorRuntime.awrap(this.getAgentWaitTime());

            case 8:
              _ref6 = _context14.sent;
              estimatedWaitTime = _ref6.estimatedWaitTime;
              // eslint-disable-next-line require-atomic-updates
              queryResult.variables.chatAvailability = availability; // eslint-disable-next-line require-atomic-updates

              queryResult.variables.estimatedChatWaitTime = _ChatbotsApiUtil["default"].getChatWaitTimeText(estimatedWaitTime);

            case 12:
              buttons = _ChatbotsApiUtil["default"].getButtons(resultMessage, queryResult); // eslint-disable-next-line no-console

              this.log("%cDF Buttons: ".concat(JSON.stringify(buttons)), 'display: block; background: #BBB; padding: 5px; color: #3A506B; font-weight: 700; font-size: 14px;');
              return _context14.abrupt("return", {
                type: _constants.CONVERSATION_TYPE_BUTTONS,
                items: buttons
              });

            case 15:
            case "end":
              return _context14.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getVariables",
    value: function getVariables(queryResult) {
      return queryResult ? _objectSpread({}, (0, _app2.getAppVariables)(this.store.getState()), {}, queryResult.variables) : _objectSpread({}, (0, _app2.getAppVariables)(this.store.getState()));
    }
  }, {
    key: "processText",
    value: function processText(resultMessage, queryResult) {
      var variables = this.getVariables(queryResult);

      var message = _ChatbotsApiUtil["default"].getMessageText(resultMessage, variables); // eslint-disable-next-line no-console


      this.log("%cDF Message: ".concat(message), 'display: block; background: #A74; padding: 5px; color: #3A506B; font-weight: 700; font-size: 14px;');
      return {
        type: _constants.CONVERSATION_TYPE_TEXT_BOT,
        items: [message],
        participantId: _constants.CHAT_PARTICIPANT_ID_CHATBOT
      };
    } // this payload share same UI with text

  }, {
    key: "processApi",
    value: function processApi(msg, queryResult) {
      var textMessage = msg && msg.payload && msg.payload.errorText; // eslint-disable-next-line no-console

      this.log("%cDF Message: ".concat(msg), 'display: block; background: #A74; padding: 5px; color: #3A506B; font-weight: 700; font-size: 14px;');

      if (queryResult.api && queryResult.api.result) {
        var messages = [{
          label: msg.payload.text || '',
          defaultLabel: msg.payload.errorText || ''
        }];

        var replacedMessages = _ChatbotsApiUtil["default"].performReplacements(messages, queryResult.api.result);

        if (replacedMessages && replacedMessages.length === 1 && replacedMessages[0].label) {
          textMessage = replacedMessages[0].label;
        }
      }

      return {
        type: _constants.CONVERSATION_TYPE_TEXT_BOT,
        items: [textMessage],
        participantId: _constants.CHAT_PARTICIPANT_ID_CHATBOT
      };
    }
  }, {
    key: "getSettings",
    value: function getSettings(resultMessage) {
      var settings = _objectSpread({}, this.store.getState().app.settings, {}, resultMessage.payload);

      delete settings.type;
      return settings;
    }
  }, {
    key: "getAgentAvailability",
    value: function getAgentAvailability() {
      var _ref7, data;

      return regeneratorRuntime.async(function getAgentAvailability$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return regeneratorRuntime.awrap(this.getAgentInfo(_constants.CHATBOT_API_ENDPOINTS.AGENT_AVAILABILITY));

            case 2:
              _ref7 = _context15.sent;
              data = _ref7.data;
              return _context15.abrupt("return", data);

            case 5:
            case "end":
              return _context15.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getAgentWaitTime",
    value: function getAgentWaitTime() {
      var _ref8, data;

      return regeneratorRuntime.async(function getAgentWaitTime$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return regeneratorRuntime.awrap(this.getAgentInfo(_constants.CHATBOT_API_ENDPOINTS.AGENT_WAITTIME));

            case 2:
              _ref8 = _context16.sent;
              data = _ref8.data;
              return _context16.abrupt("return", data);

            case 5:
            case "end":
              return _context16.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getAgentInfo",
    value: function getAgentInfo(infoEndPoint) {
      var params;
      return regeneratorRuntime.async(function getAgentInfo$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              params = {
                skillId: this.liveEngageConfig.skillName,
                account: this.liveEngageConfig.accountId
              };
              _context17.next = 3;
              return regeneratorRuntime.awrap((0, _http.request)({
                method: 'get',
                params: params,
                url: "".concat(this.endpoint, "/").concat(infoEndPoint)
              }));

            case 3:
              return _context17.abrupt("return", _context17.sent);

            case 4:
            case "end":
              return _context17.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "processSettings",
    value: function processSettings(resultMessage) {
      this.store.dispatch((0, _app.appSettingsSet)(this.getSettings(resultMessage)));
    }
  }, {
    key: "log",
    value: function log() {
      // eslint-disable-next-line no-console
      this.debug() && console.info.apply(console, arguments);
    }
  }]);

  return ChatbotsApi;
}();

exports.ChatbotsApi = ChatbotsApi;

var _default = new ChatbotsApi();

exports["default"] = _default;